import React from 'react';
import useFreshChat from 'Shared/hooks/useFreshChat';

import { ChatIcon, FixedContainer, Spinner, StyledLauncher } from './style';

const FreshChatButton = (): JSX.Element | null => {
  const { openChat, isFreshChatEnabled, isLoading, isLauncherVisible } = useFreshChat();

  // Hide the custom button if not enabled or if the default launcher is already visible
  if (!isFreshChatEnabled || isLauncherVisible) {
    return null;
  }

  return (
    <FixedContainer>
      <StyledLauncher onClick={openChat} disabled={isLoading} aria-label="Chat">
        {isLoading ? <Spinner /> : <ChatIcon id="chat-icon" />}
      </StyledLauncher>
    </FixedContainer>
  );
};

export default FreshChatButton;
